import React from 'react';
import { View, ScrollView, Text, TextInput, Alert } from 'react-native';

import Colors from "../../../constants/Colors";
import {ButtonWithSpinner, InformationDialogue, Spacing, SpinnerDialogue} from "../../../components";
import {stringIsEmpty} from "../../../constants/StringChecker";
import {EDIT_POST} from "../api/forumEndpoints";
import patch from "../../../api/methods/patch";
import NavBar from "../../../components/NavBar";

class TopicEditScreen extends React.Component {

    state = {
        answerText: "",
        isSending: false,

        showErrorModal: false,
        errorMessage: "",
        showSuccessModal: false,
    }

    handleSend = async () => {

        if (stringIsEmpty(this.state.answerText)) {
            this.setState({
                showErrorModal: true,
                errorMessage: "É necessário escrever uma resposta antes de enviar!"
            });
            return;
        }

        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {

            const postData = this.props.location.state.postData;
            const { topicId, postId } = postData;

            const payload = {
                topicId: topicId,
                postId: postId,
                postText: this.state.answerText,
            }

            const result = await patch(EDIT_POST(topicId, postId), payload);

            this.setState({ showSuccessModal: true })

        } catch (e) {
            console.log(e);
        }

        this.setState({ isSending: false });
    }


    componentDidMount() {
        const postData = this.props.location.state.postData;
        this.setState({ answerText: postData.text });
    }

    render() {

        const postData = this.props.location.state.postData;
        const answerToPost = postData.answerToPost;

        return (
            <NavBar title={"Editando"}>

                <SpinnerDialogue
                    isModalVisible={this.state.isSending}
                    onClose={() => {}}
                    isFinished={!this.state.isSending}
                    titleProps={"Salvando edição"}
                    messageProps={"Estamos salvando a sua edição."}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={this.state.errorMessage}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"A edição foi salva com sucesso!"}
                    onClose={() => this.props.history.goBack()}
                />

                <View style={{ width: 600 }}>

                    {
                        (answerToPost !== undefined && answerToPost !== null) &&
                        <View>
                            <Text style={{ fontSize: 18, color: 'white' }}>
                                Post:
                            </Text>
                            <View style={{ backgroundColor: Colors.cardBackgroundColor, borderRadius: 8 }}>
                                <Text style={{ fontSize: 14, color: 'white', padding: 8 }}>
                                    { answerToPost.text }
                                </Text>
                            </View>

                            <Spacing height={12} />
                        </View>
                    }

                    <Text style={{ fontSize: 18, color: 'white' }}>
                        Resposta:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                        value={this.state.answerText}
                        placeholder={"Escreva sua resposta aqui"}
                        placeholderTextColor={'white'}
                        onChangeText={(newValue) => this.setState({ answerText: newValue })}
                        multiline
                    />

                    <Spacing height={12} />

                    <ButtonWithSpinner
                        isLoading={this.state.isSending}
                        text={"Enviar"}
                        onPress={this.handleSend}
                        containerPropsStyle={{ height: 40, borderRadius: 8 }}
                        textPropsStyle={{ fontSize: 18, }}
                    />

                </View>
            </NavBar>
        )
    }
}

export default (TopicEditScreen);
